import React from "react";
import { __ } from "@wordpress/i18n";
import { useMenu } from "../../contexts/MenuContext";
import withForm from "../../layouts/WithForm/WithForm";
import ColorInput from "../../components/ColorInput/ColorInput";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./ColorCustomizer.scss";

const ColorCustomizer = ({ handleChange }) => {
	const { settingData } = useMenu();
  
	return (
	  <>
		<div className="content-section">
		  <div className="leftSection">
			<h2 className="title header-1 primary-text-color semi-bold">
			  {__("Color Customizer", "access-control")}
			</h2>
			<p className="description header-2 primary-text-color regular">
			  {__(
				"Specify the colors of the background of the frontend admin switcher as well as the text color. Also select specific color that you want to set for the switch button, button text and more.",
				"access-control"
			  )}
			</p>
		  </div>
  
		  <div className="rightSection">
			<div className="setting-item">
			  <div className="inputContainer">
				<OverlayTrigger
				  placement="top"
				  overlay={
					<Tooltip id="change-bar-background-tooltip">
					  {__("Change Bar Background color", "access-control")}
					</Tooltip>
				  }
				>
				  <img
					src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
					alt="icon"
					className="icon"
				  />
				</OverlayTrigger>
				<div className="inputField">
				  <span className="inputLabel">
					{__("Bar Background Color", "access-control")}
				  </span>
				  <ColorInput 
					name="bar_background_color"
					value={settingData?.global_settings?.color_customizer?.bar_background_color || "#5007aa"}
					onChange={handleChange}
				  />
				</div>
			  </div>
  
			  <div className="inputContainer">
				<OverlayTrigger
				  placement="top"
				  overlay={
					<Tooltip id="change-bar-text-tooltip">
					  {__("Change Bar Text color", "access-control")}
					</Tooltip>
				  }
				>
				  <img
					src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
					alt="icon"
					className="icon"
				  />
				</OverlayTrigger>
				<div className="inputField">
				  <span className="inputLabel">
					{__("Bar Text Color", "access-control")}
				  </span>
				  <ColorInput 
					name="bar_text_color"
					value={settingData?.global_settings?.color_customizer?.bar_text_color || "#ffffff"}
					onChange={handleChange}
				  />
				</div>
			  </div>
  
			  <div className="inputContainer">
				<OverlayTrigger
				  placement="top"
				  overlay={
					<Tooltip id="change-button-tooltip">
					  {__("Change Button Background color", "access-control")}
					</Tooltip>
				  }
				>
				  <img
					src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
					alt="icon"
					className="icon"
				  />
				</OverlayTrigger>
				<div className="inputField">
				  <span className="inputLabel">
					{__("Button Color", "access-control")}
				  </span>
				  <ColorInput 
					name="button_color"
					value={settingData?.global_settings?.color_customizer?.button_color || "#d1c1ff"}
					onChange={handleChange}
				  />
				</div>
			  </div>
  
			  <div className="inputContainer">
				<OverlayTrigger
				  placement="top"
				  overlay={
					<Tooltip id="change-button-text-tooltip">
					  {__("Change Button Text color", "access-control")}
					</Tooltip>
				  }
				>
				  <img
					src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
					alt="icon"
					className="icon"
				  />
				</OverlayTrigger>
				<div className="inputField">
				  <span className="inputLabel">
					{__("Button Text Color", "access-control")}
				  </span>
				  <ColorInput 
					name="button_text_color"
					value={settingData?.global_settings?.color_customizer?.button_text_color || "#000000"}
					onChange={handleChange}
				  />
				</div>
			  </div>
			  
			  <div className="note header-2 primary-text-color regular">
				{__(
				  "Note: Click on any color to open the color picker and choose your desired color.",
				  "access-control"
				)}
			  </div>
			</div>
		  </div>
		</div>
	  </>
	);
  };

export default withForm(ColorCustomizer, "global_settings.color_customizer");
